import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\"><path d=\"M242.48 185.248C179.52 153.76 128 185.6 128 256v512c0 70.4 51.52 102.24 114.48 70.752l539.024-269.52c62.96-31.488 62.96-83.008 0-114.48L242.48 185.248z\" fill=\"#FB6C28\" p-id=\"6984\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol